import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { alert } from '../../../base/browser/ui/aria/aria.js';
import { asArray, isNonEmptyArray } from '../../../base/common/arrays.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { illegalArgument, onUnexpectedExternalError } from '../../../base/common/errors.js';
import { URI } from '../../../base/common/uri.js';
import { EditorStateCancellationTokenSource, TextModelCancellationTokenSource } from '../../browser/core/editorState.js';
import { isCodeEditor } from '../../browser/editorBrowser.js';
import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import { DocumentFormattingEditProviderRegistry, DocumentRangeFormattingEditProviderRegistry, OnTypeFormattingEditProviderRegistry } from '../../common/modes.js';
import { IEditorWorkerService } from '../../common/services/editorWorkerService.js';
import { IModelService } from '../../common/services/modelService.js';
import { FormattingEdit } from './formattingEdit.js';
import * as nls from '../../../nls.js';
import { ExtensionIdentifier } from '../../../platform/extensions/common/extensions.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';
import { LinkedList } from '../../../base/common/linkedList.js';
import { CommandsRegistry } from '../../../platform/commands/common/commands.js';
import { assertType } from '../../../base/common/types.js';
import { Iterable } from '../../../base/common/iterator.js';
export function alertFormattingEdits(edits) {
  edits = edits.filter(function (edit) {
    return edit.range;
  });

  if (!edits.length) {
    return;
  }

  var range = edits[0].range;

  for (var i = 1; i < edits.length; i++) {
    range = Range.plusRange(range, edits[i].range);
  }

  var _range = range,
      startLineNumber = _range.startLineNumber,
      endLineNumber = _range.endLineNumber;

  if (startLineNumber === endLineNumber) {
    if (edits.length === 1) {
      alert(nls.localize('hint11', "Made 1 formatting edit on line {0}", startLineNumber));
    } else {
      alert(nls.localize('hintn1', "Made {0} formatting edits on line {1}", edits.length, startLineNumber));
    }
  } else {
    if (edits.length === 1) {
      alert(nls.localize('hint1n', "Made 1 formatting edit between lines {0} and {1}", startLineNumber, endLineNumber));
    } else {
      alert(nls.localize('hintnn', "Made {0} formatting edits between lines {1} and {2}", edits.length, startLineNumber, endLineNumber));
    }
  }
}
export function getRealAndSyntheticDocumentFormattersOrdered(model) {
  var result = [];
  var seen = new Set(); // (1) add all document formatter

  var docFormatter = DocumentFormattingEditProviderRegistry.ordered(model);

  var _iterator = _createForOfIteratorHelper(docFormatter),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var formatter = _step.value;
      result.push(formatter);

      if (formatter.extensionId) {
        seen.add(ExtensionIdentifier.toKey(formatter.extensionId));
      }
    } // (2) add all range formatter as document formatter (unless the same extension already did that)

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var rangeFormatter = DocumentRangeFormattingEditProviderRegistry.ordered(model);

  var _iterator2 = _createForOfIteratorHelper(rangeFormatter),
      _step2;

  try {
    var _loop = function _loop() {
      var formatter = _step2.value;

      if (formatter.extensionId) {
        if (seen.has(ExtensionIdentifier.toKey(formatter.extensionId))) {
          return "continue";
        }

        seen.add(ExtensionIdentifier.toKey(formatter.extensionId));
      }

      result.push({
        displayName: formatter.displayName,
        extensionId: formatter.extensionId,
        provideDocumentFormattingEdits: function provideDocumentFormattingEdits(model, options, token) {
          return formatter.provideDocumentRangeFormattingEdits(model, model.getFullModelRange(), options, token);
        }
      });
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return result;
}
export var FormattingConflicts = /*#__PURE__*/function () {
  function FormattingConflicts() {
    _classCallCheck(this, FormattingConflicts);
  }

  _createClass(FormattingConflicts, null, [{
    key: "select",
    value: function select(formatter, document, mode) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var selector;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(formatter.length === 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 2:
                selector = Iterable.first(FormattingConflicts._selectors);

                if (!selector) {
                  _context.next = 7;
                  break;
                }

                _context.next = 6;
                return selector(formatter, document, mode);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
                return _context.abrupt("return", formatter[0]);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return FormattingConflicts;
}();
FormattingConflicts._selectors = new LinkedList();
export function formatDocumentRangesWithSelectedProvider(accessor, editorOrModel, rangeOrRanges, mode, progress, token) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var instaService, model, provider, selected;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            instaService = accessor.get(IInstantiationService);
            model = isCodeEditor(editorOrModel) ? editorOrModel.getModel() : editorOrModel;
            provider = DocumentRangeFormattingEditProviderRegistry.ordered(model);
            _context2.next = 5;
            return FormattingConflicts.select(provider, model, mode);

          case 5:
            selected = _context2.sent;

            if (!selected) {
              _context2.next = 10;
              break;
            }

            progress.report(selected);
            _context2.next = 10;
            return instaService.invokeFunction(formatDocumentRangesWithProvider, selected, editorOrModel, rangeOrRanges, token);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
export function formatDocumentRangesWithProvider(accessor, provider, editorOrModel, rangeOrRanges, token) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var workerService, model, cts, ranges, len, _iterator3, _step3, _range4, allEdits, _i, _ranges, range, rawEdits, minEdits, _range2, initialSelection;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            workerService = accessor.get(IEditorWorkerService);

            if (isCodeEditor(editorOrModel)) {
              model = editorOrModel.getModel();
              cts = new EditorStateCancellationTokenSource(editorOrModel, 1
              /* Value */
              | 4
              /* Position */
              , undefined, token);
            } else {
              model = editorOrModel;
              cts = new TextModelCancellationTokenSource(editorOrModel, token);
            } // make sure that ranges don't overlap nor touch each other


            ranges = [];
            len = 0;
            _iterator3 = _createForOfIteratorHelper(asArray(rangeOrRanges).sort(Range.compareRangesUsingStarts));

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _range4 = _step3.value;

                if (len > 0 && Range.areIntersectingOrTouching(ranges[len - 1], _range4)) {
                  ranges[len - 1] = Range.fromPositions(ranges[len - 1].getStartPosition(), _range4.getEndPosition());
                } else {
                  len = ranges.push(_range4);
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            allEdits = [];
            _i = 0, _ranges = ranges;

          case 8:
            if (!(_i < _ranges.length)) {
              _context3.next = 26;
              break;
            }

            range = _ranges[_i];
            _context3.prev = 10;
            _context3.next = 13;
            return provider.provideDocumentRangeFormattingEdits(model, range, model.getFormattingOptions(), cts.token);

          case 13:
            rawEdits = _context3.sent;
            _context3.next = 16;
            return workerService.computeMoreMinimalEdits(model.uri, rawEdits);

          case 16:
            minEdits = _context3.sent;

            if (minEdits) {
              allEdits.push.apply(allEdits, _toConsumableArray(minEdits));
            }

            if (!cts.token.isCancellationRequested) {
              _context3.next = 20;
              break;
            }

            return _context3.abrupt("return", true);

          case 20:
            _context3.prev = 20;
            cts.dispose();
            return _context3.finish(20);

          case 23:
            _i++;
            _context3.next = 8;
            break;

          case 26:
            if (!(allEdits.length === 0)) {
              _context3.next = 28;
              break;
            }

            return _context3.abrupt("return", false);

          case 28:
            if (isCodeEditor(editorOrModel)) {
              // use editor to apply edits
              FormattingEdit.execute(editorOrModel, allEdits, true);
              alertFormattingEdits(allEdits);
              editorOrModel.revealPositionInCenterIfOutsideViewport(editorOrModel.getPosition(), 1
              /* Immediate */
              );
            } else {
              // use model to apply edits
              _range2 = allEdits[0].range;
              initialSelection = new Selection(_range2.startLineNumber, _range2.startColumn, _range2.endLineNumber, _range2.endColumn);
              model.pushEditOperations([initialSelection], allEdits.map(function (edit) {
                return {
                  text: edit.text,
                  range: Range.lift(edit.range),
                  forceMoveMarkers: true
                };
              }), function (undoEdits) {
                var _iterator4 = _createForOfIteratorHelper(undoEdits),
                    _step4;

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _range3 = _step4.value.range;

                    if (Range.areIntersectingOrTouching(_range3, initialSelection)) {
                      return [new Selection(_range3.startLineNumber, _range3.startColumn, _range3.endLineNumber, _range3.endColumn)];
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                return null;
              });
            }

            return _context3.abrupt("return", true);

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[10,, 20, 23]]);
  }));
}
export function formatDocumentWithSelectedProvider(accessor, editorOrModel, mode, progress, token) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var instaService, model, provider, selected;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            instaService = accessor.get(IInstantiationService);
            model = isCodeEditor(editorOrModel) ? editorOrModel.getModel() : editorOrModel;
            provider = getRealAndSyntheticDocumentFormattersOrdered(model);
            _context4.next = 5;
            return FormattingConflicts.select(provider, model, mode);

          case 5:
            selected = _context4.sent;

            if (!selected) {
              _context4.next = 10;
              break;
            }

            progress.report(selected);
            _context4.next = 10;
            return instaService.invokeFunction(formatDocumentWithProvider, selected, editorOrModel, mode, token);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}
export function formatDocumentWithProvider(accessor, provider, editorOrModel, mode, token) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var workerService, model, cts, edits, rawEdits, _edits, _edits2, range, initialSelection;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            workerService = accessor.get(IEditorWorkerService);

            if (isCodeEditor(editorOrModel)) {
              model = editorOrModel.getModel();
              cts = new EditorStateCancellationTokenSource(editorOrModel, 1
              /* Value */
              | 4
              /* Position */
              , undefined, token);
            } else {
              model = editorOrModel;
              cts = new TextModelCancellationTokenSource(editorOrModel, token);
            }

            _context5.prev = 2;
            _context5.next = 5;
            return provider.provideDocumentFormattingEdits(model, model.getFormattingOptions(), cts.token);

          case 5:
            rawEdits = _context5.sent;
            _context5.next = 8;
            return workerService.computeMoreMinimalEdits(model.uri, rawEdits);

          case 8:
            edits = _context5.sent;

            if (!cts.token.isCancellationRequested) {
              _context5.next = 11;
              break;
            }

            return _context5.abrupt("return", true);

          case 11:
            _context5.prev = 11;
            cts.dispose();
            return _context5.finish(11);

          case 14:
            if (!(!edits || edits.length === 0)) {
              _context5.next = 16;
              break;
            }

            return _context5.abrupt("return", false);

          case 16:
            if (isCodeEditor(editorOrModel)) {
              // use editor to apply edits
              FormattingEdit.execute(editorOrModel, edits, mode !== 2
              /* Silent */
              );

              if (mode !== 2
              /* Silent */
              ) {
                alertFormattingEdits(edits);
                editorOrModel.revealPositionInCenterIfOutsideViewport(editorOrModel.getPosition(), 1
                /* Immediate */
                );
              }
            } else {
              // use model to apply edits
              _edits = edits, _edits2 = _slicedToArray(_edits, 1), range = _edits2[0].range;
              initialSelection = new Selection(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
              model.pushEditOperations([initialSelection], edits.map(function (edit) {
                return {
                  text: edit.text,
                  range: Range.lift(edit.range),
                  forceMoveMarkers: true
                };
              }), function (undoEdits) {
                var _iterator5 = _createForOfIteratorHelper(undoEdits),
                    _step5;

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var _range5 = _step5.value.range;

                    if (Range.areIntersectingOrTouching(_range5, initialSelection)) {
                      return [new Selection(_range5.startLineNumber, _range5.startColumn, _range5.endLineNumber, _range5.endColumn)];
                    }
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

                return null;
              });
            }

            return _context5.abrupt("return", true);

          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2,, 11, 14]]);
  }));
}
export function getDocumentRangeFormattingEditsUntilResult(workerService, model, range, options, token) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var providers, _iterator6, _step6, provider, rawEdits;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            providers = DocumentRangeFormattingEditProviderRegistry.ordered(model);
            _iterator6 = _createForOfIteratorHelper(providers);
            _context6.prev = 2;

            _iterator6.s();

          case 4:
            if ((_step6 = _iterator6.n()).done) {
              _context6.next = 15;
              break;
            }

            provider = _step6.value;
            _context6.next = 8;
            return Promise.resolve(provider.provideDocumentRangeFormattingEdits(model, range, options, token)).catch(onUnexpectedExternalError);

          case 8:
            rawEdits = _context6.sent;

            if (!isNonEmptyArray(rawEdits)) {
              _context6.next = 13;
              break;
            }

            _context6.next = 12;
            return workerService.computeMoreMinimalEdits(model.uri, rawEdits);

          case 12:
            return _context6.abrupt("return", _context6.sent);

          case 13:
            _context6.next = 4;
            break;

          case 15:
            _context6.next = 20;
            break;

          case 17:
            _context6.prev = 17;
            _context6.t0 = _context6["catch"](2);

            _iterator6.e(_context6.t0);

          case 20:
            _context6.prev = 20;

            _iterator6.f();

            return _context6.finish(20);

          case 23:
            return _context6.abrupt("return", undefined);

          case 24:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 17, 20, 23]]);
  }));
}
export function getDocumentFormattingEditsUntilResult(workerService, model, options, token) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var providers, _iterator7, _step7, provider, rawEdits;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            providers = getRealAndSyntheticDocumentFormattersOrdered(model);
            _iterator7 = _createForOfIteratorHelper(providers);
            _context7.prev = 2;

            _iterator7.s();

          case 4:
            if ((_step7 = _iterator7.n()).done) {
              _context7.next = 15;
              break;
            }

            provider = _step7.value;
            _context7.next = 8;
            return Promise.resolve(provider.provideDocumentFormattingEdits(model, options, token)).catch(onUnexpectedExternalError);

          case 8:
            rawEdits = _context7.sent;

            if (!isNonEmptyArray(rawEdits)) {
              _context7.next = 13;
              break;
            }

            _context7.next = 12;
            return workerService.computeMoreMinimalEdits(model.uri, rawEdits);

          case 12:
            return _context7.abrupt("return", _context7.sent);

          case 13:
            _context7.next = 4;
            break;

          case 15:
            _context7.next = 20;
            break;

          case 17:
            _context7.prev = 17;
            _context7.t0 = _context7["catch"](2);

            _iterator7.e(_context7.t0);

          case 20:
            _context7.prev = 20;

            _iterator7.f();

            return _context7.finish(20);

          case 23:
            return _context7.abrupt("return", undefined);

          case 24:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[2, 17, 20, 23]]);
  }));
}
export function getOnTypeFormattingEdits(workerService, model, position, ch, options) {
  var providers = OnTypeFormattingEditProviderRegistry.ordered(model);

  if (providers.length === 0) {
    return Promise.resolve(undefined);
  }

  if (providers[0].autoFormatTriggerCharacters.indexOf(ch) < 0) {
    return Promise.resolve(undefined);
  }

  return Promise.resolve(providers[0].provideOnTypeFormattingEdits(model, position, ch, options, CancellationToken.None)).catch(onUnexpectedExternalError).then(function (edits) {
    return workerService.computeMoreMinimalEdits(model.uri, edits);
  });
}
CommandsRegistry.registerCommand('_executeFormatRangeProvider', function (accessor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var resource = args[0],
      range = args[1],
      options = args[2];
  assertType(URI.isUri(resource));
  assertType(Range.isIRange(range));
  var model = accessor.get(IModelService).getModel(resource);

  if (!model) {
    throw illegalArgument('resource');
  }

  return getDocumentRangeFormattingEditsUntilResult(accessor.get(IEditorWorkerService), model, Range.lift(range), options, CancellationToken.None);
});
CommandsRegistry.registerCommand('_executeFormatDocumentProvider', function (accessor) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var resource = args[0],
      options = args[1];
  assertType(URI.isUri(resource));
  var model = accessor.get(IModelService).getModel(resource);

  if (!model) {
    throw illegalArgument('resource');
  }

  return getDocumentFormattingEditsUntilResult(accessor.get(IEditorWorkerService), model, options, CancellationToken.None);
});
CommandsRegistry.registerCommand('_executeFormatOnTypeProvider', function (accessor) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  var resource = args[0],
      position = args[1],
      ch = args[2],
      options = args[3];
  assertType(URI.isUri(resource));
  assertType(Position.isIPosition(position));
  assertType(typeof ch === 'string');
  var model = accessor.get(IModelService).getModel(resource);

  if (!model) {
    throw illegalArgument('resource');
  }

  return getOnTypeFormattingEdits(accessor.get(IEditorWorkerService), model, Position.lift(position), ch, options);
});